const DATA = [
    {
        id : 0,
        title : "Sweat-shirt",
        price : 50,
        desc : "Size : M : Product Measurement Shoulder: 48.8 cm Length: 72 cm Sleeve Length: 63.5 cm Bust: 115 cm ",
        img : "/assets/images/products/imgcapuche.jpg"
    },
    {
        id : 1,
        title : "T.Shirt",
        price : 30,
        desc : "Size : M : Product Measurement Shoulder: 47 cm Length: 70 cm Sleeve Length: 22.5 cm Bust: 108 cm Cuff: 39 cm Bicep Length: 41.5 cm",
        img : "/assets/images/products/Tshirt.jpg"
    },
    {
        id : 2,
        title : "Jeans",
        price : 200,
        desc : "Size : M : Product Measurement Length: 106 cm, Waist Size: 85 cm, Hip Size: 108 cm, Thigh: 65 cm",
        img : "/assets/images/products/jean.jpg"
    },
    {
        id : 3,
        title : "Jacket",
        price : 90,
        desc : "Size : M",
        img : "/assets/images/products/vest.jpg"
    },
    {
        id : 4,
        title : "Shoes",
        price : 300,
        desc : "Size : 42",
        img : "/assets/images/products/shoes.jpg"
    },
    {
        id : 5,
        title : "Cap",
        price : 30,
        desc : "All size",
        img : "/assets/images/products/cap.jpg"
    }
]

export default DATA;